import React from 'react';
import { formatUSD, formatDate } from '../utils/keyGenerator';

export default function TxTable({ rows }) {
  if (!rows || !rows.length) {
    return (
      <div style={{ padding: 40, textAlign: "center", color: "var(--text3)", fontSize: 13 }}>
        No transactions yet.
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table>
        <thead>
          <tr>
            <th>Txn Reference</th>
            <th>Date</th>
            <th>Description</th>
            <th>Counterparty</th>
            <th>Account</th>
            <th>Type</th>
            <th style={{ textAlign: "right" }}>Credit</th>
            <th style={{ textAlign: "right" }}>Debit</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((tx, i) => (
            <tr key={i}>
              <td style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: "var(--gold)" }}>
                {tx.id || tx.ref}
              </td>
              <td>{formatDate(tx.date)}</td>
              <td>{tx.description || "-"}</td>
              <td style={{ color: "var(--text2)" }}>{tx.counterparty || tx.beneficiary || "-"}</td>
              <td style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, color: tx.accountIban ? 'var(--gold)' : 'var(--text3)' }}>
                {tx.accountIban ? tx.accountIban.replace(/(.{4})/g, '$1 ').trim().slice(0, 19) : 'Main'}
              </td>
              <td>
                <span className={`badge ${
                  tx.mt === "API" ? "badge-api" :
                  tx.mt === "LEDGER" ? "badge-credit" :
                  (tx.type === "RTGS" || (tx.mt && tx.mt.startsWith("RTGS"))) ? "badge-settled" :
                  "badge-ktt"
                }`}>
                  {tx.mt || tx.type}
                </span>
              </td>
              <td className="text-right" style={{ color: "var(--teal)", fontWeight: tx.creditAmount ? 600 : 400 }}>
                {tx.creditAmount ? formatUSD(tx.creditAmount) : "-"}
              </td>
              <td className="text-right" style={{ color: "var(--coral)", fontWeight: tx.debitAmount ? 600 : 400 }}>
                {tx.debitAmount ? formatUSD(tx.debitAmount) : "-"}
              </td>
              <td>
                <span className={`badge badge-${tx.status === "SETTLED" ? "settled" : "pending"}`}>
                  {tx.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
